var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconhand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3675"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.31621 1.89129L5.35481 0L0 5.16339L5.35481 10.3267L7.31621 8.43549L5.30979 6.50071H13.1431V3.82607H5.30979L7.31621 1.89129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M41.0279 0L39.2065 1.89129L41.0696 3.82607H33.7959V6.50071H41.0696L39.2065 8.43549L41.0279 10.3267L46.0002 5.16339L41.0279 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.4957 4.26839C26.3542 4.26839 28.6798 6.62579 28.6798 9.52338V13.094C30.0974 11.7093 30.9806 9.7663 30.9806 7.61302C30.9806 3.40845 27.6181 0 23.4703 0C19.3224 0 15.96 3.40845 15.96 7.61302C15.96 9.79185 16.8643 11.7553 18.3116 13.1431V9.52329C18.3116 6.6257 20.6371 4.26839 23.4957 4.26839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M38.6648 20.4629C37.2054 20.4629 36.0222 21.6464 36.0222 23.1064V21.387C36.0222 19.9271 34.8391 18.7435 33.3797 18.7435C31.9203 18.7435 30.7372 19.9271 30.7372 21.387V19.9391C30.7372 18.4792 29.5541 17.2956 28.0947 17.2956C26.6353 17.2956 25.4521 18.4792 25.4521 19.9391V9.21574C25.4521 7.75582 24.269 6.57227 22.8096 6.57227C21.3502 6.57227 20.1671 7.75582 20.1671 9.21574V23.0222C17.8159 23.2101 15.96 25.1829 15.96 27.5824V33.3232L21.9355 40.7807L21.9014 46.0015H37.1383L37.1632 40.7535L41.3073 34.2967V23.1064C41.3072 21.6464 40.1242 20.4629 38.6648 20.4629Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconhand);
export default __webpack_public_path__ + "static/media/iconhand.3190f2c74edb365914bbc11f01ded70e.svg";
export { ForwardRef as ReactComponent };